import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
        fontSize: 'sm',
        color: 'gray.800',
      },
    },
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'blue',
        size: 'md',
      },
      sizes: {
        md: {
          fontSize: 'sm',
          px: 4,
          py: 2,
        },
      },
    },
    Input: {
      defaultProps: {
        size: 'md',
      },
      sizes: {
        md: {
          field: {
            fontSize: 'sm',
            px: 3,
            py: 2,
            borderRadius: 'md',
          },
        },
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: '600',
      },
    },
    Container: {
      baseStyle: {
        maxW: 'container.md',
      },
    },
  },
});

export default theme; 